import { Vector2 } from "peet-math";
import { Control } from "./control";
import { cssDummyToStyle, getStylingDummy } from "./util";
import $ from "jquery"
import { ViewPort } from "./viewport";

// "Simple" anim because we want to gather duplicate stuff fro simple animation. For complexe animation, you might need to make your own class or improve that one with some great ideas.
export class SimpleAnim extends Control {
  public containerTag: JQuery<HTMLElement>;
  public cssDummy: any;
  public style: any;
  public visible: boolean;
  public shown: boolean;
  public radius: number;
  public maxBGAlpha: number;
  public maxBorderAlpha: number;
  public bgAlpha: number;
  public borderAlpha: number;
  public position: Vector2;
  public anim: any;

  constructor(containerTag: JQuery<HTMLElement>, cssClass: string = null) {
    super();
    this.stop = this.stop.bind(this);
    this.render = this.render.bind(this);
    this.containerTag = containerTag;
    this.cssDummy = getStylingDummy(cssClass);
    this.containerTag.append($(this.cssDummy));
    this.style = cssDummyToStyle(this.cssDummy);

    // Add stuff that would be usefull here!
    this.shown = false;
    this.radius = 50;
    this.maxBGAlpha = this.style.backgroundColorObj.rgba[3];
    this.maxBorderAlpha = this.style.borderColorObj.rgba[3];
    this.bgAlpha = 0;
    this.borderAlpha = 0;
    
    this.position = new Vector2(0, 0);
  }

  stop(renderCb) {
    this.visible = false;
    if (this.anim != null) {
      this.anim.stop();
    }
    return renderCb();
  }

  render(viewport: ViewPort, canvasCtx: CanvasRenderingContext2D) {
    if (this.visible) {
      if (!this.shown) {
        this.shown = true;
        this._showing(viewport, canvasCtx);
      }

      if (canvasCtx != null) {
        this._renderCanvas(viewport, canvasCtx);
      }
      return this._renderDom(viewport, canvasCtx);
      
    } else {
      if (this.shown) {
        this.shown = false;
        return this._hiding(viewport, canvasCtx);
      }
    }
  }

  // Triggered when becaming visible
  _showing(viewport, canvasCtx) {}
  _renderCanvas(viewport, canvasCtx) {}
  _renderDom(viewport, canvasCtx) {}
  _hiding(viewport, canvasCtx) {}
}